// AuditoriaTabXL - Sprint 44 Fase 3 Vista 10.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';

const CSS_ID = 'xl-imp-audit-css';
const CSS = `
.xl-imp-audit {
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px; font-family: var(--xl-font-sans);
}
@media (max-width: 720px) { .xl-imp-audit { grid-template-columns: 1fr } }
.xl-imp-audit__card {
  background: var(--xl-color-surface-alt);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  padding: 12px 14px;
}
.xl-imp-audit__lbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); font-weight: 600; margin-bottom: 4px;
}
.xl-imp-audit__val {
  font-family: var(--xl-font-mono); font-size: 13px;
  color: var(--xl-color-text); word-break: break-all;
}
`;

function fmt(v) {
  if (v === null || v === undefined || v === '') return '\u2014';
  return String(v);
}

export default function AuditoriaTabXL({ form }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  const rows = [
    { label: 'Creado por (user_id)', value: fmt(form.usuario_creacion) },
    { label: 'Fecha creacion', value: fmt(form.fecha_creacion) },
    { label: 'Ultima actualizacion', value: fmt(form.updated_at) },
    { label: 'Metodo de distribucion', value: fmt(form.metodo_distribucion) },
    { label: 'Fecha distribucion', value: fmt(form.fecha_distribucion) },
    { label: 'Usuario distribucion (user_id)', value: fmt(form.usuario_distribucion) },
    { label: 'PO asociada (id)', value: fmt(form.po_id) },
  ];
  return (
    <div className="xl-imp-audit">
      {rows.map((r) => (
        <div key={r.label} className="xl-imp-audit__card">
          <div className="xl-imp-audit__lbl">{r.label}</div>
          <div className="xl-imp-audit__val">{r.value}</div>
        </div>
      ))}
    </div>
  );
}
